module.exports = new __parcel__URL__("jpd-prioritization-delivery-status-dark.df6b55d9.svg").toString();